<ul
  class="nav nav-tabs tw-px-0 print:tw-hidden tw-w-full tw-min-w-[100%]"
  id="tabs"
>
  <li>
    <button mat-icon-button [matMenuTriggerFor]="menu" class="tab-menu-icon">
      <i class="mdi mdi-dots-vertical tw-text-gray-400 mdi-20px"></i>
    </button>
    <mat-menu
      #menu="matMenu"
      class="tab-menu tw-flex-center"
      xPosition="after"
      yPosition="above"
    >
      <button
        mat-menu-item
        (click)="closeAllTab()"
        class="tw-w-full tw-h-full tw-flex-center"
      >
        <div class="tw-flex-center tw-w-full tw-h-full">
          <i
            class="mdi mdi-close-circle-outline mdi-18px text-danger tw-ml-[10px] ltr:tw-mr-[10px] tw-mr-[5px] ltr:tw-ml-[5px]"
          ></i>
          <span class="mat-menu-title">{{
            "common.closeAll" | translate
          }}</span>
        </div>
      </button>
    </mat-menu>
  </li>

  <li
    *ngFor="let tab of tabs()"
    (mousedown)="selectTab(tab)"
    class="nav-item example-box"
  >
    <a class="nav-link" [class.active]="tab.active">
      <span class="static-tab-title">{{ tab.title | translate }}</span>
      <span>
        <i class="static-tab-icon fas fa-home tw-pt-1.5 tw-mx-1"></i>
      </span>

      <span class="tab-refresh">
        <i
          class="fas fa-redo-alt tw-pt-1.5 tw-mx-1"
          (click)="refreshStaticTab(tab.name)"
        ></i>
      </span>
    </a>
  </li>

  <!-- dynamic tabs -->
  <li *ngFor="let tab of dynamicTabs" (click)="selectTab(tab)" class="nav-item">
    <a
      class="nav-link"
      [class.active]="tab.active"
      (click)="getActiveTab(tab.name)"
    >
      <span
        class="tab-title"
        [ngClass]="{ 'dark:tw-text-primary-200': tab.active }"
        [matTooltip]="tab.title | translate"
      >
        {{ tab.title | translate }}
      </span>

      <span
        class="tab-refresh"
        *ngIf="isShowRefreshBtn(tab.name); else hideRefreshBtn"
      >
        <i class="fas fa-redo-alt tw-pt-1" (click)="refreshTab(tab.name)"></i>
      </span>

      <ng-template #hideRefreshBtn>
        <span class="tab-refresh">
          <span class="fas fa-redo-alt tw-pt-1 tw-opacity-0"></span>
        </span>
      </ng-template>

      <span class="tab-close" *ngIf="tab.isCloseable">
        <i class="fas fa-times-circle" (click)="closeTab(tab)"></i>
      </span>

      <span class="tab-sm">
        <i class="fas fa-sort-down"></i>
      </span>
    </a>
  </li>
</ul>
<div class="fix-tab"></div>
<div class="row">
  <div class="tw-w-full" id="content_block"></div>
</div>

<ng-content></ng-content>

<ng-template dynamic-tabs #container></ng-template>
